import { useDocumentSelection } from "@/stores/useDocumentSelection";

export const useDocumentSelectionStore = (documentId: string) => {
  return useDocumentSelection(documentId)();
};
